export default "__VITE_ASSET__BUl22SJ9__"